import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyCardModule as MatCardModule} from '@angular/material/legacy-card';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {MatLegacySelectModule as MatSelectModule} from '@angular/material/legacy-select';
import {MatSortModule} from '@angular/material/sort';
import {MatLegacyTableModule as MatTableModule} from '@angular/material/legacy-table';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {RouterModule} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {SimplebarAngularModule} from 'simplebar-angular';
import {DetailPartnerComponent} from '../components/detail-views/detail-partner/detail-partner.component';
import {FilterPipe, NewLicenseDialogComponent,} from '../components/detail-views/detail-partner/new-license-dialog/new-license-dialog.component';
import {DetailUserComponent} from '../components/detail-views/detail-user/detail-user.component';
import {LicenseListComponent} from '../components/license-list/license-list.component';
import {NewPartnerComponent} from '../components/new-view/new-partner/new-partner.component';
import {NewUserComponent} from '../components/new-view/new-user/new-user.component';
import {PartnerAdministrationComponent} from '../components/partner-administration/partner-administration.component';
import {MandatsreferenzDialogComponent} from '../components/partner-list/mandatsreferenz-dialog/mandatsreferenz-dialog.component';
import {PartnerListComponent} from '../components/partner-list/partner-list.component';
import {DavePartnerAdministrationRoutingModule} from './dave-partner-administration-routing.module';
import {MatLegacyListModule as MatListModule} from '@angular/material/legacy-list';
import {MatLegacySlideToggleModule as MatSlideToggleModule} from '@angular/material/legacy-slide-toggle';
import {AppButtonModule} from '../dave-utils-module/app-button-module/app-button.module';
import {DaveSharedComponentsModule} from '../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { DaveDoubleIconModule } from '../dave-double-icon/dave-double-icon.module';
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';

@NgModule({
  declarations: [
    PartnerListComponent,
    PartnerAdministrationComponent,
    NewPartnerComponent,
    DetailPartnerComponent,
    NewLicenseDialogComponent,
    FilterPipe,
    DetailUserComponent,
    NewUserComponent,
    LicenseListComponent,
    MandatsreferenzDialogComponent,
    MandatsreferenzDialogComponent,
  ],
  imports: [
    CommonModule,
    DavePartnerAdministrationRoutingModule,
    MatCardModule,
    FontAwesomeModule,
    SimplebarAngularModule,
    MatDividerModule,
    MatButtonModule,
    MatDialogModule,
    DaveSharedComponentsModule,
    AppButtonModule,
    MatTooltipModule,
    MatTableModule,
    MatSortModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    RouterModule,
    MatSelectModule,
    FormsModule,
    MatListModule,
    MatSlideToggleModule,
    DaveDoubleIconModule,
    DaveLoadingModule,
  ],
  exports: [
    FilterPipe,
  ],
  // entryComponents: [
  //     NewLicenseDialogComponent,
  //     MandatsreferenzDialogComponent,
  // ],
})
export class DavePartnerAdministrationModule {
}
